import { useMemo } from 'react';
import Fuse from 'fuse.js';
import { useDevices } from 'app/agriculture/queries/devices/useDevices';

export function useDeviceResults(textFilter: string) {
    const devices = useDevices();

    const fuse = useMemo(
        () =>
            new Fuse(Array.from(devices.values()), {
                keys: [
                    { name: 'name', weight: 1 },
                    { name: 'deviceType', weight: 0.6 },
                    { name: 'externalId', weight: 0.2 },
                ],
            }),
        [devices],
    );

    return useMemo(
        () =>
            !textFilter
                ? Array.from(devices.values())
                : fuse.search(textFilter).map(({ item }) => item),
        [textFilter, fuse, devices],
    );
}
